import { useRef } from "react";
import { motion, useMotionValue, useSpring, useTransform } from "framer-motion";
import { logo } from "@/lib/site";

export default function Logo3D({ imgClass = "h-24 w-auto", wrapperClass = "", testid }) {
  const ref = useRef(null);
  const mx = useMotionValue(0);
  const my = useMotionValue(0);

  const rotateX = useSpring(useTransform(my, [-0.5, 0.5], [14, -14]), { stiffness: 160, damping: 14 });
  const rotateY = useSpring(useTransform(mx, [-0.5, 0.5], [-20, 20]), { stiffness: 160, damping: 14 });

  const handleMove = (e) => {
    const r = ref.current?.getBoundingClientRect();
    if (!r) return;
    mx.set((e.clientX - r.left) / r.width - 0.5);
    my.set((e.clientY - r.top) / r.height - 0.5);
  };
  const handleLeave = () => {
    mx.set(0);
    my.set(0);
  };

  return (
    <div
      ref={ref}
      onMouseMove={handleMove}
      onMouseLeave={handleLeave}
      className={`inline-block ${wrapperClass}`}
      style={{ perspective: 700 }}
      data-testid={testid}
    >
      <motion.img
        src={logo}
        alt="LocalNova Web Design"
        style={{ rotateX, rotateY, transformStyle: "preserve-3d" }}
        className={`logo-3d ${imgClass}`}
      />
    </div>
  );
}
